import { Flex, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { DefaultProps } from 'typings'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from '../Section'
import { messages } from './messages'

export function Accumulations(props: DefaultProps) {
  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage {...messages.title} />
          </SectionTitle>
          <Text tone="secondary">
            <FormattedMessage {...messages.subtitle} />
          </Text>
        </Flex>
      </SectionHeader>
      <SectionContent>{props.children}</SectionContent>
    </Section>
  )
}
